<div class="notification-bell-container">
  <!-- Notification Bell Icon -->
  <button
    class="notification-bell-btn"
    (click)="toggleDropdown()"
    [class.connected]="isConnected"
    [class.disconnected]="!isConnected"
  >
    <i class="pi pi-bell"></i>
    <span *ngIf="unreadCount > 0" class="notification-badge" [class.many]="unreadCount > 9">
      {{ unreadCount > 99 ? '99+' : unreadCount }}
    </span>
    <div class="connection-indicator" [class.connected]="isConnected"></div>
  </button>

  <!-- Notification Dropdown -->
  <div *ngIf="showDropdown" class="notification-dropdown" (click)="$event.stopPropagation()">
    <div class="notification-header">
      <h3>Notifications</h3>
      <div class="notification-actions">
        <button *ngIf="unreadCount > 0" class="mark-all-read-btn" (click)="markAllAsRead()">
          Mark all read
        </button>
        <button
          *ngIf="notifications.length > 0"
          class="clear-all-btn"
          (click)="clearAllNotifications()"
        >
          Clear all
        </button>
      </div>
    </div>

    <div class="notification-list">
      <div *ngIf="notifications.length === 0" class="no-notifications">
        <i class="pi pi-bell-slash"></i>
        <p>No notifications</p>
      </div>

      <div
        *ngFor="let notification of notifications.slice(0, 10)"
        class="notification-item"
        [class.unread]="!notification.read"
        (click)="markAsRead(notification)"
      >
        <div class="notification-icon">
          <i
            [class]="
              getNotificationIcon(notification.type) + ' ' + getNotificationColor(notification.type)
            "
          ></i>
        </div>
        <div class="notification-content">
          <div class="notification-title">{{ notification.title }}</div>
          <div class="notification-message">{{ notification.message }}</div>
          <div class="notification-time">{{ getTimeAgo(notification.timestamp) }}</div>
        </div>
        <button class="delete-notification-btn" (click)="deleteNotification(notification, $event)">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>

    <div *ngIf="notifications.length > 10" class="notification-footer">
      <p>{{ notifications.length - 10 }} more notifications</p>
    </div>
  </div>
</div>
